module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#cinema",
      toString: function () {
        return this.url;
      }
    }